import { useQuery } from '@tanstack/react-query';
import { schedulerMonitorApi } from '../api/schedulerMonitorApi';

/**
 * GET /scheduler-monitor/batch/jobs/{jobName}/executions — 배치 실행 이력 페이징 (SCHEDULER_READ)
 * queryKey: ['scheduler-monitor', 'batch-executions', jobName, page, size]
 */
export function useBatchExecutions(params: {
  jobName: string | null;
  page: number;
  size: number;
}) {
  return useQuery({
    queryKey: ['scheduler-monitor', 'batch-executions', params.jobName, params.page, params.size],
    queryFn: () =>
      schedulerMonitorApi.listBatchExecutions({
        jobName: params.jobName!,
        page: params.page,
        size: params.size,
      }),
    enabled: params.jobName !== null,
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  });
}
